module.exports = __webpack_public_path__ + "img/image 19.292a8871.png";